import { useState } from "react";
import { motion } from "framer-motion";
import { useMunicipalStore } from "../../store/municipalStore";
import Button from "../shared/Button";
import Modal from "../shared/Modal";
import { Header, Container } from "../shared/Layout";
import { MapPin, Upload, Send } from "lucide-react";
import MapPicker from "../MapPicker";

export default function PresidenteNuevaSolicitud({ presidentialId }) {
  const { createRequest, areas, barrios } = useMunicipalStore();
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    barrio: "",
    tipo: "",
    descripcion: "",
    urgencia: "media",
    lat: null,
    lng: null,
    fotos: []
  });

  const handleSubmit = async () => {
    if (!form.barrio || !form.tipo || !form.descripcion) {
      alert("Por favor completa todos los campos requeridos");
      return;
    }

    setLoading(true);
    
    // Simular envío
    setTimeout(() => {
      createRequest({
        ...form,
        presidentialId,
        lat: form.lat || -17.893625,
        lng: form.lng || -63.327754
      });

      alert("✅ Solicitud enviada correctamente. Tu requerimiento está siendo procesado.");
      
      setForm({
        barrio: "",
        tipo: "",
        descripcion: "",
        urgencia: "media",
        lat: null,
        lng: null,
        fotos: []
      });
      
      setLoading(false);
      setIsOpen(false);
    }, 1000);
  };

  return (
    <div className="flex justify-center ">
      <div className="m-px-4 w-[100%] max-w-[500px]">
        <div className="space-y-6">
          {/* Step Indicator */}
          <div className="flex gap-2">
            {[1, 2, 3].map(step => (
              <div key={step} className="flex-1 h-2 bg-blue-300 rounded-full opacity-50" />
            ))}
          </div>

          <div className="space-y-4">
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">
                Barrio *
              </label>
              <select
                value={form.barrio}
                onChange={(e) => setForm({ ...form, barrio: e.target.value })}
                className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <option value="">Selecciona tu barrio</option>
                {barrios.map(b => (
                  <option key={b.id} value={b.name}>{b.name}</option>
                ))}
              </select>
            </div>

            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">
                Tipo de Problema *
              </label>
              <select
                value={form.tipo}
                onChange={(e) => setForm({ ...form, tipo: e.target.value })}
                className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <option value="">Selecciona el tipo</option>
                <option value="caminos">🛣️ Problemas de Caminos</option>
                <option value="alumbrado">💡 Alumbrado</option>
                <option value="areas_verdes">🌳 Áreas Verdes</option>
                <option value="basura">🗑️ Recolección de Basura</option>
                <option value="agua">💧 Servicios de Agua</option>
              </select>
            </div>

            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">
                Descripción del Problema *
              </label>
              <textarea
                value={form.descripcion}
                onChange={(e) => setForm({ ...form, descripcion: e.target.value })}
                placeholder="Describe el problema con detalle..."
                rows={4}
                className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 resize-none"
              />
            </div>

            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">
                Nivel de Urgencia
              </label>
              <div className="flex gap-2">
                {["baja", "media", "alta"].map(level => (
                  <button
                    key={level}
                    onClick={() => setForm({ ...form, urgencia: level })}
                    className={`flex-1 py-2 rounded-lg font-medium transition-all ${
                      form.urgencia === level
                        ? "bg-blue-600 text-white shadow-lg"
                        : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                    }`}
                  >
                    {level === "baja" ? "🟢 Baja" : level === "media" ? "🟡 Media" : "🔴 Alta"}
                  </button>
                ))}
              </div>
            </div>

            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">
                Adjuntar Foto (Opcional)
              </label>
              <div className="border-2 border-dashed border-blue-300 rounded-xl p-6 text-center cursor-pointer hover:bg-blue-50 transition-colors">
                <Upload className="mx-auto mb-2 text-blue-500" size={32} />
                <p className="text-sm text-gray-600">Haz clic para subir una foto</p>
              </div>
            </div>

            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">
                Ubicación en Mapa (Opcional)
              </label>
              <MapPicker
                onChange={(pos) =>
                    setForm({
                    ...form,
                    lat: pos.lat,
                    lng: pos.lng
                    })
                }
                />
                {form.lat && (
                <p className="text-xs text-gray-600 mt-2">
                    📍 Ubicación seleccionada:
                    {form.lat.toFixed(5)}, {form.lng.toFixed(5)}
                </p>
                )}
            </div>
          </div>

          <div className="flex gap-3">
            <Button variant="secondary" onClick={() => setIsOpen(false)} className="flex-1">
              Cancelar
            </Button>
            <Button
              variant="primary"
              icon={Send}
              onClick={handleSubmit}
              loading={loading}
              className="flex-1"
            >
              Enviar Solicitud
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
